<template>
  <form-wrapper :title="option.title"
                :description="option.description"
                @submit="submit()"
                @previous="previous()"
                :isFirst="isFirst"
                :isLast="isLast"
                :disabled="isSaving">
    
      <b-form-group label="First Name" label-class="control-label" :class="{ 'invalid-group': $v.form.firstName.$error }">
        <b-form-input v-model="form.firstName" @input="handleInput" :class="{ 'is-invalid': $v.form.firstName.$error }"></b-form-input>
        <span class="span-feedback invalid-feedback" v-if="$v.form.firstName.$error">You must enter a first name.</span>
      </b-form-group>

      <b-form-group label="Last Name" label-class="control-label" :class="{ 'invalid-group': $v.form.lastName.$error }">
        <b-form-input v-model="form.lastName" @input="handleInput" :class="{ 'is-invalid': $v.form.lastName.$error }"></b-form-input>
        <span class="span-feedback invalid-feedback" v-if="$v.form.lastName.$error">You must enter a last name.</span>
      </b-form-group>

      <b-form-group label="Title" label-class="control-label" :class="{ 'invalid-group': $v.form.title.$error }">
        <b-form-input v-model="form.title" @input="handleInput" :class="{ 'is-invalid': $v.form.title.$error }"></b-form-input>
        <span class="span-feedback invalid-feedback" v-if="$v.form.title.$error">You must enter a title.</span>
      </b-form-group>
      
      <b-form-group label="Phone Number" label-class="control-label" :class="{ 'invalid-group': $v.form.phoneNumber.$error }">
        <b-form-input v-model="form.phoneNumber" @input="handleInput" :class="{ 'is-invalid': $v.form.phoneNumber.$error }"></b-form-input>
        <span class="span-feedback invalid-feedback" v-if="$v.form.phoneNumber.$error">You must enter a valid phone number.</span>
      </b-form-group>

      <b-form-group label="Email" label-class="control-label" :class="{ 'invalid-group': $v.form.email.$error }">
        <b-form-input v-model="form.email" @input="handleInput" :class="{ 'is-invalid': $v.form.email.$error }"></b-form-input>
        <span class="span-feedback invalid-feedback" v-if="$v.form.email.$error">You must enter an email.</span>
      </b-form-group>

      <b-form-group v-if="isSLPA" label="ASHA #" label-class="control-label" :class="{ 'invalid-group': $v.form.ashaNumber.$error }">
        <b-form-input v-model="form.ashaNumber" @input="handleInput" :class="{ 'is-invalid': $v.form.ashaNumber.$error }" maxlength="10"></b-form-input>
        <span class="span-feedback invalid-feedback" v-if="$v.form.ashaNumber.$error">You must enter an ASHA #.</span>
      </b-form-group>

      <b-form-group v-if="isSLPA" label="AZ SLP #" label-class="control-label" :class="{ 'invalid-group': $v.form.azSlpNumber.$error }">
        <b-form-input v-model="form.azSlpNumber" @input="handleInput" :class="{ 'is-invalid': $v.form.azSlpNumber.$error }" maxlength="10"></b-form-input>
        <span class="span-feedback invalid-feedback" v-if="$v.form.azSlpNumber.$error">You must enter an AZ SLP #.</span>
      </b-form-group>



  </form-wrapper>
</template>

<script>
import { mapActions, mapState } from "vuex";
import { required } from "vuelidate/lib/validators";
import * as _ from "lodash";
import formWrapper from "./form-wrapper";

export default {
  data() {
    return {
      form: {
        firstName: "",
        lastName: "",
        title: "",
        phoneNumber: "",
        email: "",
        siteContactId: 0
      },
      supervisorOptions: [],
      isSaving: false
    };
  },

  props: {
    option: {
      type: Object,
      required: true
    },
    isFirst: {
      type: Boolean,
      required: false,
      default: false
    },
    isLast: {
      type: Boolean,
      required: false,
      default: false
    }
  },

  components: {
    "form-wrapper": formWrapper
  },

  validations() {
    var validations = {
      form: {
        siteContactId: {},
        firstName: {
          required
        },
        lastName: {
          required
        },
        title: {
          required
        },
        phoneNumber: {
          required
        },
        email: {
          required
        },
        ashaNumber: {},
        azSlpNumber: {}
      }
    };

    if (this.isSLPA) {
      validations.form.ashaNumber = { required };
      validations.form.azSlpNumber = { required };
    }

    return validations;
  },

  computed: {
    ...mapState({
      userId: state => state.auth.user.userId,
      studentOpportunityId: state =>
        state.additionalMaterials.studentOpportunityId,
      studentOpportunity: state => state.additionalMaterials.studentOpportunity,
      contact: state => state.additionalMaterials.contact,
      supervisors: state => state.additionalMaterials.supervisors
    }),
    isSLPA() {
      return (
        this.studentOpportunity.opportunity.opportunityCategory.name.indexOf(
          "SLPA"
        ) > 0
      );
    }
  },

  methods: {
    ...mapActions("placements", ["postStudentOpportunityContact"]),
    handleInput: function() {
      this.returnItem();
    },
    validate: function() {
      this.$v.$touch();
      this.returnItem();
    },
    returnItem: function() {
      this.$emit("input", this.form);
    },
    isInvalid: function() {
      return this.$v.$invalid;
    },
    previous: function() {
      this.$emit("previous");
    },
    submit: function() {
      this.$v.$touch();

      if (!this.$v.$invalid) {
        this.isSaving = true;
        var siteContactId = this.form.siteContactId
          ? this.form.siteContactId
          : 0;
        this.form.siteContactId = siteContactId;
        this.postStudentOpportunityContact({
          studentOpportunity: {
            studentOpportunityId: this.studentOpportunityId,
            studentOpportunityContacts: [
              {
                studentOpportunityId: this.studentOpportunityId,
                siteContactId: siteContactId,
                siteContact: this.form
              }
            ]
          }
        })
          .then(response => {
            if (response) {
              this.$emit("submitted");
            }
          })
          .finally(() => {
            this.isSaving = false;
          });
      }
    },
    mapSupervisors: function(supervisors) {
      return _.map(supervisors, function(supervisor) {
        return {
          siteContactId: supervisor.siteContactId,
          text: supervisor.firstName + " " + supervisor.lastName
        };
      });
    }
  },

  watch: {
    contact: {
      handler: function() {
        if (this.contact) {
          this.form = this.contact;
          this.form.siteContactId = 0;
        }
      },
      deep: true
    },
    supervisors: {
      handler: function() {
        this.supervisorOptions = this.mapSupervisors(this.supervisors);
      }
    }
  },

  created() {
    this.supervisorOptions = this.mapSupervisors(this.supervisors);
    if (this.contact) {
      this.form = this.contact;
      this.form.siteContactId = 0;
    }
  }
};
</script>

<style>
.form-horizontal .control-label {
  padding-bottom: 0;
  font-size: 13px;
}
</style>
